// extracted by mini-css-extract-plugin
export var btn = "lowerBanner-module--btn--aNbQd";
export var descr = "lowerBanner-module--descr--4YHNI";
export var gethalva = "lowerBanner-module--gethalva--ys6rK";
export var img = "lowerBanner-module--img--OuJFk";
export var section = "lowerBanner-module--section--3oLgD";
export var textBlock = "lowerBanner-module--textBlock--wU7hx";
export var title = "lowerBanner-module--title--d4LT5";
export var wrap = "lowerBanner-module--wrap--K0Obl";